import axios from "axios";

const api = axios.create({ baseURL: 'https://vitru-trade-backend-production.up.railway.app' });

export function setAuthToken(token) {
  if (token) {
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    localStorage.setItem('access_token', token);
  } else {
    delete api.defaults.headers.common['Authorization'];
    localStorage.removeItem('access_token');
  }
}

const saved = localStorage.getItem('access_token');
if (saved) api.defaults.headers.common['Authorization'] = `Bearer ${saved}`;

export default api;